import { SIZES } from "./data";

export const SizePicker = ({ value, onChange, testPrefix = "size", compact = false }) => (
  <div
    data-testid={`${testPrefix}-picker`}
    role="radiogroup"
    className={`flex flex-wrap ${compact ? "gap-1.5" : "gap-2"}`}
  >
    {SIZES.map((s) => {
      const active = value === s;
      return (
        <button
          key={s}
          type="button"
          role="radio"
          aria-checked={active}
          data-testid={`${testPrefix}-option-${s.toLowerCase()}`}
          onClick={() => onChange(active ? null : s)}
          className={`${compact ? "h-9 min-w-[44px] px-3 text-[10px]" : "h-11 min-w-[52px] px-4 text-[11px]"} rounded-full border font-mono-d uppercase tracking-[0.15em] transition-all duration-300 ${
            active
              ? "bg-[#0a0a0b] border-[#0a0a0b] text-white shadow-[0_8px_24px_-10px_rgba(10,10,11,0.6)]"
              : "bg-[#ffffff] border-[#e3e2dc] text-[#0a0a0b] hover:border-[#ff2a85]"
          }`}
        >
          {s}
        </button>
      );
    })}
  </div>
);
